<template>
  <v-page page="assetUpdate" title="Create & Edit Assets">
    <v-container fluid>
      <v-layout column>
        <v-layout>
          <v-flex>
            <v-text-field v-model="query"
                          :placeholder="this.placeholderText"
                          clearable solo
                          @keydown.enter="getFileReferences"
                          data-test="searchInput"></v-text-field>
          </v-flex>
          <v-flex xs1 class="ml-2">
            <v-select v-model="attribute"
                      :items="attributeChoices"
                      solo></v-select>
          </v-flex>
          <v-flex class="searchbar-btn" xs2 lg1 ml-2>
            <v-btn @click="getFileReferences" color="primary">Search</v-btn>
          </v-flex>
        </v-layout>
        <v-dialog
          v-model="fileUploading"
          hide-overlay
          width="35">
        <v-card class="cardColor">
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
        </v-card>
      </v-dialog>
        <v-flex>
          <v-data-table
                class="elevation-1"
                :headers="tableHeaders"
                :items="assets"
                item-key="id"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc">
                <template v-slot:item="props">
                  <tr>
                    <th>
                      <v-flex mb-5>
                        <v-checkbox
                          :value="props.item.isSelected"
                          primary
                          hide-details
                          @click="rowSelected(props.item)"
                        ></v-checkbox>
                      </v-flex>
                    </th>
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.filename }}</td>
                    <td>{{ props.item.sha }}</td>
                    <td>{{ props.item.mime_type }}</td>
                    <td>{{ props.item.is_staged | booleanYesNo }}</td>
                    <td>{{ props.item.is_secure | booleanYesNo }}</td>
                    <td>{{ props.item.created_at | dateTime }}</td>
                    <td>{{ props.item.updated_at | dateTime }}</td>
                    <td>{{ props.item.promoted_at | dateTime }}</td>
                    <td><a :href="props.item.url" target="assetPreview">Preview</a></td>
                  </tr>
                </template>
              </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout ml-3 right>
        <v-flex mt-2>
          <input
            class="d-none"
            type="file"
            :ref="inputRef"
            @change="parse($event.target.files)"/>
            <v-btn
              :color="browseButtonColor"
              :ref="buttonRef"
              @click.native="file['filename'] != null || allCheckboxSelected ? validateAndUpload() : $refs[inputRef].click()">
              <v-icon left>
                {{ saveButtonIcon() }}
              </v-icon>
                {{ saveButtonText() }}
            </v-btn>
          </v-flex>
        </v-layout>
      <v-layout ml-5>
        <v-flex mt-5 sm8>
          <v-layout>
            <v-text-field
              :disabled="true"
              :label="this.hint"
              :value="this.file['filename']">
            </v-text-field>
            <v-flex mt-1 ml-5>
              <v-checkbox
                label="Stage Asset"
                v-model="file['is_staged']"
                @change="updateFileFlags()">
              </v-checkbox>
            </v-flex>
            <v-flex mt-1 ml-5>
              <v-checkbox
                label="Secure Asset"
                v-model="file['is_secure']"
                @change="updateFileFlags()">
              </v-checkbox>
            </v-flex>
          </v-layout>
          <v-flex ml-5>
            <div
              v-for="(tagField, i) in tagFields"
              :key="i"
              class="text-fields-row">
              <v-layout sm-4>
                <v-flex mt-2>
                  <v-btn text icon color="red" @click="removeTagField(i)" :disabled="tagFields.length == 1 || selected.length > 1">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex mr-5 pr-3>
                  <v-text-field
                    :label="tagField.nameLabel"
                    v-model="tagField.tagName"
                    :disabled="selected.length > 1">
                  </v-text-field>
                </v-flex>
                <v-flex mr-3>
                  <v-text-field
                    :label="tagField.valueLabel"
                    v-model="tagField.tagValue"
                    :disabled="selected.length > 1">
                  </v-text-field>
                </v-flex>
                <v-flex mt-2 ml-4 pr-2>
                  <v-btn text icon color="primary" @click="addTagField" :disabled="tagField.tagValue.length == 0 || tagField.tagName.length == 0 || selected.length > 1">
                    <v-icon>add_circle</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>
<script>
import VPage from '@/layouts/Default'
import { Bus } from '@/bus'
import { servers } from '@/helpers'
import store from '@/store'

export default {
  name: 'AssetUpdate',
  components: {
    VPage
  },
  props: {
    browseButtonText: {
      type: String,
      default: 'Browse File'
    },
    browseButtonIcon: {
      default: 'search'
    },
    browseButtonColor: {
      default: 'primary'
    },
    uploadButtonText: {
      type: String,
      default: 'Upload File'
    },
    saveChangesButtonText: {
      type: String,
      default: 'Save Changes'
    },
    saveChangesButtonIcon: {
      default: 'save'
    },
    uploadButtonIcon: {
      default: 'cloud_upload'
    },
    uploadButtonColor: {
      default: 'primary'
    }
  },
  data () {
    return {
      hint: 'Filename',
      query: '',
      fileUploading: false,
      attribute: 'tags',
      sortBy: 'id',
      sortDesc: true,
      attributeChoices: [
        { value: 'tags', text: 'Tags' },
        { value: 'ids', text: 'Id' }
      ],
      allCheckboxSelected: false,
      tagFields: [],
      tagsToRemove: {},
      tagsToAdd: {},
      file: {
        'id': null,
        'filename': null,
        'sha': null,
        'mime_type': null,
        'is_staged': false,
        'is_secure': false
      },
      assets: [],
      loading: false,
      selected: [],
      tableHeaders: [
        { text: '', value: 'isSelected', sortable: false, width: '50px' },
        { text: 'Asset Id', value: 'id', sortable: true, width: '100px' },
        { text: 'Filename', value: 'filename', sortable: true },
        { text: 'Storage Filename', value: 'sha', sortable: true },
        { text: 'Mimetype', value: 'mime_type', sortable: true },
        { text: 'Is Staged', value: 'is_staged', sortable: true },
        { text: 'Is Secure', value: 'is_secure', sortable: true },
        { text: 'Created At', value: 'created_at', sortable: true },
        { text: 'Updated At', value: 'updated_at', sortable: true },
        { text: 'Promoted At', value: 'promoted_at', sortable: true },
        { text: 'Url', value: 'url', sortable: false }
      ]
    }
  },
  computed: {
    inputRef () {
      return `file-input-${this._uid}`
    },
    buttonRef () {
      return `file-button-${this._uid}`
    },
    placeholderText () {
      if (this.attribute === 'tags') {
        return 'version:1.2.3,revision:5abcd'
      } else {
        return '1,2,3'
      }
    }
  },
  mounted () {
    this.getFileReferences()
  },
  methods: {
    addTagField (tagId = null, tagName = '', tagValue = '') {
      this.tagFields.push({
        id: tagId,
        nameLabel: 'Tag Name',
        tagName: tagName,
        origTagName: tagName,
        valueLabel: 'Tag Value',
        tagValue: tagValue,
        origTagValue: tagValue
      })
    },
    updateFileFlags () {
      if (this.file['id']) {
        this.selected.filter(item => {
          if (item['id'] === this.file['id']) {
            item['is_staged'] = this.file['is_staged']
            item['is_secure'] = this.file['is_secure']
          }
        })
      }
    },
    saveButtonText () {
      var isBrowseEnabled = servers[store.state.auth.server].asset_browse_enabled

      if (!this.file['id'] && this.file['filename']) {
        return this.uploadButtonText
      } else if (this.file['id'] || !isBrowseEnabled || this.allCheckboxSelected) {
        return this.saveChangesButtonText
      } else {
        return this.browseButtonText
      }
    },
    saveButtonIcon () {
      var isBrowseEnabled = servers[store.state.auth.server].asset_browse_enabled

      if (!this.file['id'] && this.file['filename']) {
        return this.uploadButtonIcon
      } else if (this.file['id'] || !isBrowseEnabled || this.allCheckboxSelected) {
        return this.saveChangesButtonIcon
      } else {
        return this.browseButtonIcon
      }
    },
    rowSelected (item) {
      this.clearFileFields()

      if (item.isSelected) {
        this.$set(item, 'isSelected', false)
        if (this.selected.length > 0) {
          this.file = this.selected[this.selected.length - 1]
          for (var tagName in this.selected[this.selected.length - 1].tags) {
            this.selected[this.selected.length - 1].tags[tagName].forEach((tagValue) => {
              this.addTagField(item.id, tagName, tagValue)
            })
          }

          let removeIndex = this.selected.map(item => item.id).indexOf(item.id)
          if (removeIndex >= 0) {
            this.selected.splice(removeIndex, 1)
          }
        } else {
          this.clearSelectionFields()
          this.clearFileFields()
        }
      } else {
        this.$set(item, 'isSelected', true)
        this.file = JSON.parse(JSON.stringify(item))
        this.selected.push(JSON.parse(JSON.stringify(item)))

        if (Object.keys(item.tags).length > 0) {
          for (var tagProperty in item.tags) {
            item.tags[tagProperty].forEach((tagValue) => {
              this.addTagField(item.id, tagProperty, tagValue)
            })
          }
        } else {
          this.addTagField()
        }
      }
    },
    clearFileFields () {
      this.tagFields = []
      this.file.id = null
      this.file.filename = null
      this.file.sha = null
      this.file.mime_type = null
      this.file.is_staged = false
      this.file.is_secure = false
      this.tagsToAdd = {}
      this.tagsToRemove = {}
    },
    clearSelectionFields () {
      this.allCheckboxSelected = false
      this.selected.splice(0)
    },
    removeTagField (index) {
      if (this.tagFields[index].id) {
        this.tagsToRemove[this.tagFields[index].tagName] = this.tagFields[index].tagValue
      }

      if (this.tagFields.length === 1) {
        this.tagFields[0].tagName = ''
        this.tagFields[0].tagValue = ''
      } else {
        this.tagFields.splice(index, 1)
      }
    },
    async parse (files) {
      if (Array.from(files).length !== 1) {
        let error = new Error('Accept only one file per upload!')
        error.name = 'Multiple Files'
        console.error(error)
        this.$set(this, 'errors', [{
          name: 'General',
          errors: [ error ]
        }])
        return
      }

      let file = files[0]

      if (file) {
        let reader = new FileReader()

        reader.onload = e => {
          this.file = {}
          this.file['data'] = e.target.result
          this.file['filename'] = file.name
          this.file['mime_type'] = file.type
        }
        reader.readAsArrayBuffer(file)
      }

      this.addTagField()
    },
    async validateAndUpload () {
      if (this.file.id && this.selected.length === 1) {
        this.tagFields.forEach((tag) => {
          if (tag.id == null && tag.tagName.length === 0 && tag.tagValue.length === 0) { // Skip new full blank entry
            return
          }
          if (tag.id && tag.tagName.length === 0 && tag.tagValue.length === 0) {
            this.tagsToRemove[tag.origTagName] = tag.origTagValue
          } else if (tag.tagName !== tag.origTagName && tag.tagValue !== tag.origTagValue) { // New entry
            if (tag.tagName in this.tagsToAdd) {
              this.tagsToAdd[tag.tagName].push(tag.tagValue)
            } else {
              this.tagsToAdd[tag.tagName] = [tag.tagValue]
            }

            if (tag.id) {
              this.tagsToRemove[tag.origTagName] = tag.origTagValue
            }
          } else if (tag.id && tag.tagName === tag.origTagName && tag.tagValue !== tag.origTagValue) { // Update existing entry
            if (tag.tagName in this.tagsToAdd) {
              this.tagsToAdd[tag.tagName].push(tag.tagValue)
            } else {
              this.tagsToAdd[tag.tagName] = [tag.tagValue]
            }
          }
        })
        await this.updateFile(this.file, this.tagsToAdd, this.tagsToRemove)
      } else if (this.selected.length > 1) {
        this.selected.forEach(async (selectedFile) => {
          let file = selectedFile

          file.is_staged = this.file.is_staged
          file.is_secure = this.file.is_secure

          await this.updateFile(file, null, null)
        })
      } else {
        await this.uploadFile()
      }
    },
    async updateFile (updatedFile, tagsAdded, tagsRemoved) {
      if (updatedFile) {
        var assetHeaders = {}

        if (tagsAdded) {
          assetHeaders['add_tags'] = tagsAdded
        }
        if (tagsRemoved) {
          assetHeaders['remove_tags'] = tagsRemoved
        }
        assetHeaders['is_staged'] = updatedFile['is_staged']
        assetHeaders['is_secure'] = updatedFile['is_secure']

        this.fileUploading = true

        await this.$store.dispatch('assets/updateFile', { 'sha': updatedFile['sha'], 'assetHeaders': assetHeaders }).then((result) => {
          Bus.$emit('alert', { color: 'success', message: 'Succesfully updated asset' })
        }).catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to update asset' })
        }).finally(async () => {
          this.clearFileFields()
          this.clearSelectionFields()
          await this.getFileReferences()
          this.fileUploading = false
        })
      }
    },
    async uploadFile () {
      this.tagFields.forEach((tag) => {
        if (tag.tagName.length > 0 && tag.tagValue.length > 0) { // Delete new key/value that are both blank
          this.tagsToAdd[tag.tagName] = tag.tagValue
        }
      })

      this.fileUploading = true
      this.tagsToAdd.name = this.file.filename

      await this.$store.dispatch('assets/uploadFile', { file: this.file, tags: this.tagsToAdd }).then((result) => {
        Bus.$emit('alert', { color: 'success', message: 'Succesfully uploaded asset' })
      }).catch(() => {
        Bus.$emit('alert', { color: 'error', message: 'Failed to upload asset' })
      }).finally(async () => {
        this.clearFileFields()
        this.clearSelectionFields()
        await this.getFileReferences()
        this.fileUploading = false
      })
    },
    async getFileReferences () {
      this.assets.splice(0)

      await this.$store.dispatch('assets/fetchAssets', this.attribute ? { type: this.attribute, values: this.query } : null).then((result) => {
        this.assets.splice(0)

        for (let i = 0; i < result['assets'].length; ++i) {
          result['assets'][i].isSelected = false
          this.assets.push(result['assets'][i])
        }
      })
        .catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve assets' })
        })
    }
  }
}
</script>
<style lang="sass">
.cardColor
  position: absolute
  width: 0%
  height: 0%
</style>
